import React from 'react';
import { GraduationCap, Handshake, ImageIcon } from 'lucide-react';

const Events = () => {
  const eventPhotos = [
    // KIET MOU event photographs — to be added when provided by the client.
    // Example shape: { src: 'https://...', caption: 'MOU signing ceremony at KIET' }
  ];

  return (
    <div>
      <section
        className="relative py-24 bg-[#1E56A0] text-white overflow-hidden"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1523580494863-6f3031224c94?q=80&w=2070&auto=format&fit=crop)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-[#1E56A0]/95"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 lg:px-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4" data-testid="events-heading">
            Events Gallery
          </h1>
          <p className="text-xl text-slate-200 max-w-3xl mx-auto leading-relaxed">
            Industry collaborations, academic partnerships, training activities, and corporate events
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div
            className="border-2 border-slate-200 rounded-sm overflow-hidden hover:border-[#FF7F2A] hover:shadow-lg transition-all duration-300"
            data-testid="event-card-kiet"
          >
            <div className="p-8 md:p-10">
              <div className="flex items-start gap-6 mb-6">
                <div className="bg-[#1E56A0] text-white rounded-sm p-4 flex-shrink-0">
                  <Handshake className="w-10 h-10" />
                </div>
                <div className="flex-grow">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    <h2 className="text-2xl md:text-3xl font-semibold text-slate-900">
                      MOU with KIET Deemed to be University
                    </h2>
                    <span className="bg-[#FF7F2A] text-white text-xs font-semibold px-3 py-1 rounded-sm flex items-center gap-1">
                      <GraduationCap className="w-3.5 h-3.5" /> Academic Partnership
                    </span>
                  </div>
                  <div className="space-y-4 text-base leading-relaxed text-slate-600">
                    <p>
                      Usha Automation has partnered with KIET Deemed to be University through a
                      Memorandum of Understanding (MOU) to support industry-oriented training and
                      practical exposure for students.
                    </p>
                    <p>
                      The initiative focuses on bridging the gap between academics and industry by
                      providing students with hands-on learning opportunities in Industrial Automation,
                      PLC, SCADA, IIoT, and related industrial technologies.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Event Gallery</h3>
                {eventPhotos.length > 0 ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {eventPhotos.map((photo, index) => (
                      <figure
                        key={index}
                        className="overflow-hidden rounded-sm border-2 border-slate-200 hover:border-[#1E56A0] transition-all group"
                        data-testid={`event-photo-${index}`}
                      >
                        <img
                          src={photo.src}
                          alt={photo.caption}
                          className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-300"
                        />
                        {photo.caption && (
                          <figcaption className="px-4 py-3 text-sm text-slate-600 bg-slate-50 border-t border-slate-200">
                            {photo.caption}
                          </figcaption>
                        )}
                      </figure>
                    ))}
                  </div>
                ) : (
                  <div
                    className="border-2 border-dashed border-slate-300 rounded-sm bg-slate-50 py-16 px-6 text-center"
                    data-testid="event-photos-placeholder"
                  >
                    <ImageIcon className="w-12 h-12 text-slate-400 mx-auto mb-4" />
                    <p className="text-slate-500 font-medium">Event photographs will be added soon</p>
                    <p className="text-slate-400 text-sm mt-1">
                      Photographs from the KIET MOU signing ceremony are being prepared.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Partner With Usha Automation
          </h2>
          <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto">
            Interested in academic collaborations, industrial training, or technical partnerships? Let's connect.
          </p>
          <a
            href="/contact"
            className="inline-flex items-center bg-[#1E56A0] text-white hover:bg-[#164e8a] rounded-sm px-8 py-4 font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
            data-testid="events-cta-button"
          >
            Get in Touch
          </a>
        </div>
      </section>
    </div>
  );
};

export default Events;
